import React, { useReducer } from "react";
import { useForm } from "react-hook-form";
import errorHistoryService from "./errorHistoryService";
import { useTranslation } from "react-i18next";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import { Grid } from "@material-ui/core";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";

const columnsErrorHistory = (t) => [
    {
        field: "errorCode",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="id" />;
        }, flex: 1
    },
    {
        field: "message",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="description" />;
        }, flex: 1
    },
    {
        field: "errorOrigin",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="origin" />;
        }, flex: 1
    },
    {
        field: "startDate",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="date" />;
        }, flex: 1
    },
    {
        field: "nameUser",
        textAlign: 'center',
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="user" />;
        }, flex: 1
    },
];

function reducer(state, action) {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.data }
        case "clear":
            return initialErrorHistoryState
        case 'success':
            return { ...state, success: true, error: false }
        case 'error':
            return { ...state, success: false, error: true }
        case 'close_alert':
            return { ...state, success: false, error: false }
        default:
            return new Error();
    }
}

const initialErrorHistoryState = {
    errorCode: "",
    idUser: 0,
    startDate: null,
    endDate: null,
    errorHistoryRows: [],
};

export default function ErrorHistory() {
    const { t } = useTranslation();
    const { control } = useForm();

    const [errorHistory, dispatch] = useReducer(reducer, initialErrorHistoryState);
    const { errorCode, idUser, startDate, endDate, errorHistoryRows } = errorHistory

    const handleChange = ({ target: { name, value } }) => {
        dispatch({
            type: 'update',
            data: { [name]: value }
        })
    };

    const searchErrorHistory = () => {
        const { errorHistoryRows, ...data } = errorHistory
        errorHistoryService
            .get(data)
            .then((response) => {
                for (let i = 0; i < response.data.length; i++) {
                    response.data[i] = { id: i, ...response.data[i] };
                }
                dispatch({
                    type: 'update',
                    data: { errorHistoryRows: response.data }
                })
            })
            .catch((e) => dispatch({
                type: 'update',
                data: { errorHistoryRows: [] }
            }));
    };

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="erroHistory"
                fields={
                    <GridItemContainer>
                        <GridInputRow>
                            <Grid item xs={12} sm={6} md={2}>
                                <InputField
                                    name="errorCode"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={errorCode}
                                    length={20}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <DefaultAutocomplete
                                    name={"idUser"}
                                    onChange={handleChange}
                                    value={idUser}
                                    label={t("user")}
                                    defaultSize
                                    useApi
                                    endpoint='GetUserAutocomplete'
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <CustomDatePicker
                                    id="startDatePicker"
                                    name="startDate"
                                    selectedDate={startDate}
                                    handleChange={handleChange}
                                    disableFuture={true}
                                    error={
                                        endDate !== null &&
                                        startDate > endDate
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <CustomDatePicker
                                    id="endDatePicker"
                                    name="endDate"
                                    selectedDate={endDate}
                                    handleChange={handleChange}
                                    disableFuture={true}
                                    error={
                                        endDate !== null &&
                                        startDate > endDate
                                    }
                                />
                            </Grid>
                        </GridInputRow>
                        <SearchClearSaveRow
                            onClickSearch={searchErrorHistory}
                            onClickClear={() => dispatch({ type: 'clear' })}
                        />
                    </GridItemContainer>
                }
            />
            {errorHistoryRows.length > 0 ? (
                <DefaultScreenAccordion
                    title="erroHistoryGrid"
                    fields={
                        <Grid item xs={12}>
                            <DefaultDatagrid
                                muiColumns={true}
                                dataSource={errorHistoryRows}
                                columns={columnsErrorHistory(t)}
                                disableSelectionOnClick={true}
                            />
                        </Grid>
                    } />
            ) : null}
        </>
    );
};
